export default {

    methods: {
        notEmptyObject(someObject) {
            return Object.keys(someObject).length;
        }
    }
}